module.exports = __webpack_public_path__ + "static/media/final-finish-section.d6b57e3f.webp";